import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { validateRole } from "../../util/utilFunction";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";
import axios from "axios";

export const useListProdukSP = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [isRefresh, setIsRefresh] = useState(false);
  const [listProduk, setListProduk] = useState();
  const [customer, setCustomer] = useState("GS");
  const [namaProduk, setNamaProduk] = useState("");
  const [addNewCustomer, setAddNewCustomer] = useState("Pilih Perusahaan");
  const [popUpTambahProduk, setPopUpTambahProduk] = useState(false);
  const [targetPrinting, setTargetPrinting] = useState("");
  const [targetPunching, setTargetPunching] = useState("");
  const [targetSticker, setTargetSticker] = useState("");

  const [targetUltrasonic, setTargetUltrasonic] = useState("");
  const [targetTestBocor, setTargetTestBocor] = useState("");
  const [targetFillingPlug, setTargetFillingPlug] = useState("");
  const [targetSortir, setTargetSortir] = useState("");
  const [targetPutusRonce, setTargetPutusRonce] = useState("");
  const [targetBnw, setTargetBnw] = useState("");
  const [targetPasangHandle, setTargetPasangHandle] = useState("");
  const [targetValveFilter, setTargetValveFilter] = useState("");

  const [popUpEdit, setPopUpEdit] = useState(false);
  const [pickProduk, setPickProduk] = useState();
  const [pickDelete, setPickDelete] = useState();
  const [popUpDelete, setPopUpDelete] = useState(false);

  const [file, setFile] = useState(null);

  const [dataListBarang, setDataListBarang] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
      { tim: dataUser.tim, bagian: validateRole(), type: "getProduk" },
      dataUser.auth,
      setListProduk,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListTierSatu`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataListBarang,
      ""
    );
    setIsRefresh(false);
  }, [isRefresh]);

  let dataListBarangTemp = {};

  dataListBarang &&
    dataListBarang.forEach((element) => {
      if (element.company === customer) {
        dataListBarangTemp = element;
      }
    });

  const dataPick = () => {
    let data;
    listProduk &&
      listProduk.forEach((element) => {
        if (element.customer === customer) {
          data = element;
        }
      });
    return data;
  };
  const Material = dataPick();

  const handleAddProduk = () => {
    const dataPR = {
      targetPrint: Number(targetPrinting),
      targetPunching: Number(targetPunching),
      targetPasangStiker: Number(targetSticker),
      produk: namaProduk,
    };
    const dataSP = {
      targetUltrasonic: Number(targetUltrasonic),
      targetTestBocor: Number(targetTestBocor),
      targetFilling: Number(targetFillingPlug),
      targetSortir: Number(targetSortir),
      targetPutusRonce: Number(targetPutusRonce),
      targetValveFilter: Number(targetValveFilter),
      targetBnw: Number(targetBnw),
      targetPasangHandle: Number(targetPasangHandle),
      produk: namaProduk,
      id: uuidv4(),
    };

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
      {
        tim: dataUser.tim,
        bagian: validateRole(),
        type: "addNewProduk",
        customer: addNewCustomer,
        data: validateRole() === "SP" ? dataSP : dataPR,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefresh(true);
    setNamaProduk("");
    setTargetPrinting("");
    setTargetPunching("");
    setTargetSticker("");
    setTargetUltrasonic("");
    setTargetTestBocor("");
    setTargetFillingPlug("");
    setTargetPutusRonce("");
    setTargetSortir("");
    setTargetBnw("");
    setTargetValveFilter("");
    setTargetPasangHandle("");
    setPopUpTambahProduk(false);
    setAddNewCustomer("Pilih Perusahaan");
  };

  const handlePickEdit = (e) => {
    setPickProduk(e);
    setPopUpEdit(true);
  };

  const handleChangeEditProduk = (event, type) => {
    if (type === "barangJadi") {
      setPickProduk({
        ...pickProduk,
        [`barangJadi`]: event,
      });
    } else {
      setPickProduk({
        ...pickProduk,
        [event.target.name]: Number(event.target.value),
      });
    }
  };

  const handleKirimEditProduk = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
      {
        tim: dataUser.tim,
        bagian: validateRole(),
        type: "editProduk",
        customer: customer,
        data: pickProduk,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefresh(true);
    setPopUpEdit(false);
  };

  const handleDeleteListBarangSp = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
      {
        tim: dataUser.tim,
        bagian: validateRole(),
        type: "deleteListProduk",
        customer: customer,
        id: pickDelete.id,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefresh(true);
    setPopUpDelete(false);
    setPickDelete();
  };

  const handleImportBarangPolos = () => {
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/importBarangPolos`,
          { data: json, tim: dataUser.tim },
          {
            headers: {
              Authorization: `Bearer ${dataAuth}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setFile(null);
    }
  };

  return {
    dataUser,
    customer,
    setCustomer,
    Material,
    handleAddProduk,
    namaProduk,
    setNamaProduk,
    targetPrinting,
    setTargetPrinting,
    targetPunching,
    setTargetPunching,
    targetSticker,
    setTargetSticker,
    targetUltrasonic,
    setTargetUltrasonic,
    targetTestBocor,
    setTargetTestBocor,
    targetFillingPlug,
    setTargetFillingPlug,
    popUpTambahProduk,
    setPopUpTambahProduk,
    addNewCustomer,
    setAddNewCustomer,
    popUpEdit,
    setPopUpEdit,
    handlePickEdit,
    pickProduk,
    handleChangeEditProduk,
    handleKirimEditProduk,
    targetSortir,
    setTargetSortir,
    targetPutusRonce,
    setTargetPutusRonce,
    targetBnw,
    setTargetBnw,
    targetPasangHandle,
    setTargetPasangHandle,
    targetValveFilter,
    setTargetValveFilter,
    popUpDelete,
    setPopUpDelete,
    handleDeleteListBarangSp,
    pickDelete,
    setPickDelete,
    setFile,
    handleImportBarangPolos,
    dataListBarangTemp,
  };
};
